import React, {createContext} from 'react';

export const CollectContext = createContext();

const CollectContextProvider = props => {
    const {context = null, children} = props;

    return <CollectContext.Provider value={context}>{children}</CollectContext.Provider>;
};

export default CollectContextProvider;
